// start:ng42.barrel
import './clone-timetable-route.component';
import './transport-timetable-add.component';
import './transport-timetable-edit.component';
import './transport-timetable-list.component';
import './transport-timetable-routes.component';
import './transport-timetables.component';
// end:ng42.barrel

